import {
  jb_article_card_css_default
} from "./chunk.Y2NKDOMD.js";
import {
  Linkable
} from "./chunk.MFPI4EPN.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-card/jb-article-card.ts
var JbArticleCard = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this.direction = "vertical";
  }
  render() {
    const classes = {
      horizontal: this.direction === "horizontal",
      vertical: this.direction === "vertical",
      "no-image": !this.teaserHeader.picture && !this.teaserHeader.thumbnail
    };
    return ke`
      <article class="${Rt(classes)}">
        ${this.direction === "horizontal" ? ke`
              <a
                class="image-link"
                data-linkable
              >
                ${this.teaserHeader.picture ? ke`
                      <jb-picture
                        .alt=${this.teaserHeader.picture.alt}
                        .fit=${"cover"}
                        .imgData=${this.teaserHeader.picture.imgData}
                        .lazy=${this.teaserHeader.picture.lazy}
                      ></jb-picture>
                    ` : D}
                ${this.teaserHeader.thumbnail ? ke`
                      <jb-thumbnail
                        .backgroundPicture="${this.teaserHeader.thumbnail.backgroundPicture}"
                        .videoSrc="${this.teaserHeader.thumbnail.videoSrc}"
                        .aspect="${this.teaserHeader.thumbnail.aspect}"
                        .type="${this.teaserHeader.thumbnail.type}"
                      ></jb-thumbnail>
                    ` : D}
              </a>
            ` : D}
        <div class="wrapper">
          <a
            class="text-link"
            data-linkable
          >
            ${this.direction !== "horizontal" ? ke`
                  <jb-teaser-header
                    .headline=${this.teaserHeader.headline}
                    .picture=${this.teaserHeader.picture}
                    .teaser=${this.teaserHeader.teaser}
                    .thumbnail=${this.teaserHeader.thumbnail}
                    ?gallery=${this.gallery}
                  ></jb-teaser-header>
                ` : ke` <h3>${this.teaserHeader.headline}</h3> `}
          </a>
          ${this.teaserMeta ? ke`<jb-teaser-meta
                .date=${this.teaserMeta.date}
                .category=${this.teaserMeta.category}
                .time=${this.teaserMeta.time}
                .link=${this.teaserMeta.link ? this.teaserMeta.link : this.link}
              ></jb-teaser-meta>` : D}
        </div>
      </article>
    `;
  }
};
JbArticleCard.styles = [reset_css_default, jb_article_card_css_default];
__decorateClass([
  n()
], JbArticleCard.prototype, "direction", 2);
__decorateClass([
  n({ type: Boolean })
], JbArticleCard.prototype, "gallery", 2);
__decorateClass([
  n({ type: Object })
], JbArticleCard.prototype, "teaserHeader", 2);
__decorateClass([
  n({ type: Object })
], JbArticleCard.prototype, "teaserMeta", 2);
JbArticleCard = __decorateClass([
  customElement("jb-article-card")
], JbArticleCard);

export {
  JbArticleCard
};
